import script from "./DateFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./DateFilters.vue?vue&type=script&setup=true&lang=js"

import "./DateFilters.vue?vue&type=style&index=0&id=50e18533&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50e18533"]])

export default __exports__